import React from 'react';
// @material-ui/core
import {
  Grid,
  Typography,
  CircularProgress
} from '@material-ui/core';
// @material-ui/icons
import {
  AccessTime,
  AttachMoney as AttachMoneyIcon,
} from '@material-ui/icons';

import { Helmet } from 'react-helmet';

// core components
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';

import styles from 'assets/jss/material-dashboard-react/views/dashboardStyle.js';

import {
  Line as RC2Line
} from 'react-chartjs-2';
import 'chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes';
import { Aspect6 } from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.office';

import ReactResizeDetector from 'react-resize-detector';

import CoupangPartners from '../../components/CoupangPartners/CoupangPartners';

import APIServer from '../../config/server.conf.json';

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: {
        fxi: true,
      }
    };
  }

  componentDidMount() {
    fetch(`${APIServer.baseUrl}/api/v1/fxi/stats`)
      .then((resp) => resp.json())
      .then((resp) => {
        if(resp.status === 200 && resp.data.rows) {
          let chart_data = {
            labels: resp.data.rows[0].data.map((e) => e.date),
            datasets: []
          };

          for(let i in resp.data.rows) {
            let row = resp.data.rows[i];

            let label = `${row.name} (${row.mark})`;

            chart_data.datasets.push({
              label: label,
              pointBorderWidth: 3,
              fill: false,
              hidden: row.name !== '달러',
              lineTension: 0,
              data: row.data.map((e) => ({ x: e.date, y: e.value }))
            });
          }

          this.setState({
            chart_data: chart_data,
            isLoading: {
              ...this.state.isLoading,
              fxi: false,
            }
          });
        }
      });
  }

  render() {
    return (
      <div>
        {/* <div>
          {JSON.stringify(this.state)}
        </div> */}
        <Helmet
          title="TBX Dashboard"
          meta={[
            { name: "description", content: "TBX Dashboard" },
            { name: "keywords", content: "toolbox, tbx, 툴박스" },
            { property: "og:title", content: "TBX Dashboard - TBX" },
            { property: "og:description", content: "TBX Dashboard - TBX" },
            { property: "og:title", content: "TBX Dashboard - TBX" },
          ]}
        />
        <Grid container>
          {/* <Grid item xs={12}>
            <CoupangPartners />
          </Grid> */}
          <Grid item xs={12}>
            <ReactResizeDetector handleWidth handleHeight>
              {({ width, height }) => <CoupangPartners width={width} height={height} />}
            </ReactResizeDetector>
          </Grid>
          {this.state.chart_data &&
          <Grid item xs={12}>
            <Card chart>
              <CardHeader color="success">
                <Typography variant="h6"><AttachMoneyIcon style={{ verticalAlign: 'sub' }} />환율</Typography>
              </CardHeader>
              {this.state.isLoading.fxi &&
              <CardBody style={{ alignSelf: 'center', padding: 50 }}>
                <CircularProgress color="secondary" size={50} />
              </CardBody>
              }
              {!this.state.isLoading.fxi &&
              <CardBody style={{ minHeight: 300 }}>
                <RC2Line
                  style={{ margin: 10 }}
                  data={this.state.chart_data}
                  options={{
                    responsive: true,
                    legend: {
                      position: 'right',
                    },
                    tooltips: {
                      mode: 'index',
                      intersect: false,
                    },
                    maintainAspectRatio: false,
                    plugins: {
                      colorschemes: {
                        scheme: Aspect6
                      }
                    }
                  }}
                />
              </CardBody>
              }
            </Card>
          </Grid>}
        </Grid>
      </div>
    );
  }
}